// Connection status and the background-tab title. The server unloads a
// player whose socket closes, so offline really means the hunt is paused;
// the banner says so, counts down to the next retry and offers to retry now.
import { trainerXpToNext } from '../shared/xp.ts';
import { S } from './state.ts';

let retryAt = () => 0;
let retryNow = () => {};
let wasDown = false;
let backTimer: ReturnType<typeof setTimeout> | null = null;

export function bindConnection(o: { retryAt: () => number; retryNow: () => void }) {
  retryAt = o.retryAt; retryNow = o.retryNow;
}

function host() {
  let el = document.getElementById('netbanner');
  if (!el) {
    el = document.createElement('div');
    el.id = 'netbanner'; el.className = 'netbanner'; el.hidden = true;
    el.setAttribute('role', 'status');
    el.innerHTML = '<span class="msg"></span> <button class="btn tiny" type="button">Retry now</button>';
    el.querySelector('button')!.addEventListener('click', () => retryNow());
    document.body.appendChild(el);
  }
  return el;
}

/** Seconds until the next reconnect attempt, or 0 while one is running. */
export function retryIn() { return Math.max(0, Math.ceil((retryAt() - Date.now()) / 1000)); }

/** Short status for the app bar: "Online", "Reconnecting in 6 s" or "Offline · hunting paused". */
export function statusText() {
  if (S.online) return 'Online';
  const s = retryIn();
  return s > 0 ? `Reconnecting in ${s} s` : 'Offline · hunting paused';
}

export function renderBanner() {
  const el = host();
  const chip = document.getElementById('netstatus');
  if (chip) { chip.textContent = statusText(); chip.className = `net ${S.online ? 'on' : retryIn() > 0 ? 'wait' : 'off'}`; }
  if (!S.online) {
    if (backTimer) { clearTimeout(backTimer); backTimer = null; }
    wasDown = true;
    el.hidden = false; el.className = 'netbanner down';
    const s = retryIn();
    el.querySelector('.msg')!.textContent = `Connection lost · hunting paused · ${s > 0 ? `Retrying in ${s} s` : 'Reconnecting…'} ·`;
    (el.querySelector('button') as HTMLElement).hidden = false;
  } else if (wasDown) {
    wasDown = false;
    el.hidden = false; el.className = 'netbanner up';
    el.querySelector('.msg')!.textContent = 'Back online · hunting resumed';
    (el.querySelector('button') as HTMLElement).hidden = true;
    backTimer = setTimeout(() => { el.hidden = true; backTimer = null; }, 3000);
  }
}

export function titleText() {
  const t = S.trainer;
  if (!S.online) return 'Offline · Legendkin';
  if (!t) return 'Legendkin';
  const pct = Math.floor((t.xp / trainerXpToNext(t.level)) * 100);
  return `Hunting · Lv ${t.level} (${pct}%) · Legendkin`;
}

/** The banner counts down once a second; the tab title follows the hunt every 10 s while hidden. */
export function startStatusClock() {
  setInterval(() => { if (!S.online) renderBanner(); }, 1000);
  setInterval(() => { if (document.hidden) document.title = titleText(); }, 10_000);
  document.addEventListener('visibilitychange', () => { document.title = document.hidden ? titleText() : 'Legendkin'; });
}

/** Call when the socket goes up or down. */
export function onConnection() {
  renderBanner();
  if (document.hidden) document.title = titleText();
}
